export default () => {
  const TextWeight = {
    Unbounded_bold: "Unbounded-Bold",
    Unbounded_semiBold: "Unbounded-SemiBold",
    Unbounded_medium: "Unbounded-Medium",
    Unbounded_regular: "Unbounded-Regular",
    Unbounded_light: "Unbounded-Light",
    Montserrat_bold: "Montserrat-Bold",
    Montserrat_semiBold: "Montserrat-SemiBold",
    Montserrat_medium: "Montserrat-Medium",
    Montserrat_regular: "Montserrat-Regular",
    Montserrat_light: "Montserrat-Light",
    JosefinSans_bold: "JosefinSans-Bold",
    JosefinSans_semiBold: "JosefinSans-SemiBold",
    JosefinSans_medium: "JosefinSans-Medium",
    JosefinSans_regular: "JosefinSans-Regular",
    Caveat_regular: "Caveat-Regular",
    Caveat_bold: "Caveat-Bold",
    Caveat_light: "Caveat-Light",
    Onest_bold: "Onest-Bold",
    Onest_semiBold: "Onest-SemiBold",
    Onest_medium: "Onest-Medium",
    Onest_regular: "Onest-Regular",
    Onest_light: "Onest-Light",
    Onest_extraBold: "Onest-ExtraBold",
  };

  return { TextWeight };
};
